import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ToastContainer, toast } from 'react-toastify';
import axios from '../config/axios';
import { extractEmails, extractPhoneNumber, phoneFormat, validRegex } from "../helper/helper";
const initialState = {
    companyName: '',
    companyContactNumber: '',
    companyUrl: '',
    emailToSendLeads: [],
    phoneNumberToSendLead: '',
    websiteManagerName: '',
    websiteManagerEmail: '',
    additionalNotes: '',
    emailLead: '',
    readAndAgree: false,
    submitDisable: false
};

export const postDemoForm = createAsyncThunk("postDemoForm", async (arg, { rejectWithValue }) => {
    try {
        const { data } = await axios.post('/playgroundController/saveDemoForm', arg);
        return data;
    } catch (error) {
        rejectWithValue(error);
    }
})
export const demoFormSlice = createSlice({
    name: 'demoForm',
    initialState,
    reducers: {
        onAddFormInput: (state, { payload }) => {
            if (payload[0] === 'phoneNumberToSendLead' || payload[0] === 'companyContactNumber') {
                let phonenum = payload[1];
                if (phonenum.startsWith('(') && phonenum.length === 4) {
                    phonenum = phonenum.slice(0, (phonenum.length - 1));
                }
                state[payload[0]] = phoneFormat(phonenum);
            } else {
                let inputValue = payload[1];
                if (payload[0] === 'emailLead' && inputValue.includes(',')) {
                    inputValue = '';
                }
                state[payload[0]] = inputValue;
            }

        },
        addEmailLeadList: (state, { payload }) => {
            state.emailLead = '';
            state.emailToSendLeads.push(payload);
        },
        deleteEmailLead: (state, { payload }) => {
            const allList = JSON.parse(JSON.stringify(state.emailToSendLeads));
            allList.splice(payload, 1);
            state.emailToSendLeads = allList;
        },
        checkAgree: (state, { payload }) => {
            state.readAndAgree = !state.readAndAgree;
        }
    },
    extraReducers: {
        [postDemoForm.pending]: (state, { payload }) => {
            state.loading = true;
            state.submitDisable = true;
        },
        [postDemoForm.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.submitDisable = false;
            if (payload.status) {
                state.companyName = '';
                state.companyContactNumber = '';
                state.companyUrl = '';
                state.emailToSendLeads = [];
                state.phoneNumberToSendLead = '';
                state.websiteManagerName = '';
                state.websiteManagerEmail = '';
                state.additionalNotes = '';
                state.emailLead = '';
                state.readAndAgree = false;
                toast.success(payload.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            } else {
                toast.error(payload.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        },
        [postDemoForm.rejected]: (state, { payload }) => {
            state.loading = false;
            state.submitDisable = false;
            toast.error('Something went wrong.', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }
});

export const demoFormAction = demoFormSlice.actions;
export default demoFormSlice.reducer;
